export const setCookie = (name: string, value: string, delay: number): void => {
  document.cookie = [
    `${name}=${value}`,
    'path=/',
    'domain=.ohou.se',
    `expires=${new Date(Date.now() + delay).toUTCString()}`,
  ].join(';');
  document.cookie = [
    `${name}=${value}`,
    'path=/',
    `expires=${new Date(Date.now() + delay).toUTCString()}`,
  ].join(';');
};
